import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { subscribeQuotes, mergeQuotes } from "@/lib/marketStream";

export function usePrices(intervalMs = 20000) {
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updates, setUpdates] = useState({});
  useEffect(() => subscribeQuotes(setUpdates), []);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/crypto/prices");
      setCoins(data.coins || []);
    } catch {
      // keep previous
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, intervalMs);
    return () => clearInterval(id);
  }, [load, intervalMs]);

  return { coins: mergeQuotes(coins, updates), loading, reload: load };
}

export function fmtPrice(p) {
  if (p == null) return "-";
  if (p >= 1000) return p.toLocaleString("en-US", { maximumFractionDigits: 2 });
  if (p >= 1) return p.toFixed(2);
  return p.toFixed(6);
}
